const pentestingRoutes = [

{
    path: '/pentesting',
    name: 'PentestingMenuComponent',
    component: () => import('../views/pentesting/PentestingMenuComponent.vue'),
    meta: {
        requiresAuth: true,
        module: 'pentesting'
    }
},
{
    path: '/standard-scan',
    name: 'StandardScan',
    component: () => import('../views/pentesting/StandardScan.vue'),
    meta: {
        requiresAuth: true,
        module: 'pentesting'
    }
},
// En tu archivo de rutas
{
    path: '/pentesting/history',
    name: 'ScanHistory',
    component: () => import('@/views/pentesting/ScanHistory.vue'),
    meta: { requiresAuth: true, module: 'pentesting' }
},
{
    path: '/pentesting/schedules',
    name: 'ScanSchedules',
    component: () => import('@/views/pentesting/ScanSchedulesComponent.vue'),
    meta: { requiresAuth: true, module: 'pentesting', planFeature: 'scheduled_scans' }
}

];

export default pentestingRoutes;